import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=905e0c0e&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"
import style0 from "./hero.vue?vue&type=style&index=0&id=905e0c0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905e0c0e",
  null
  
)

export default component.exports